import { ca } from '@cian/analytics';
import { EEntityType } from '../../types/filters';

export function trackCategoryClick(type: EEntityType | null) {
  ca('event', {
    name: 'oldevent',
    action: 'click',
    category: 'ListingFavorites',
    label: type === EEntityType.Newbuilding ? 'newbuilding' : 'offer',
  });
}
